import React from 'react';
import HeroSection from '../components/home/HeroSection';
import CakeCarousel from '../components/home/CakeCarousel';
import InstagramFeed from '../components/home/InstagramFeed';
import Testimonials from '../components/home/Testimonials';

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <CakeCarousel />
      <InstagramFeed />
      <Testimonials />
    </div>
  );
};

export default HomePage;
